import { render, staticRenderFns } from "./EditMntCategory.vue?vue&type=template&id=866ba8b6&"
import script from "./EditMntCategory.vue?vue&type=script&lang=js&"
export * from "./EditMntCategory.vue?vue&type=script&lang=js&"
import style0 from "./EditMntCategory.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports